module.exports = ".kan-term-dialog-container {\n  font-size: 13px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/modules/admin/dialogs/term-dialog/component.scss
// module id = ./src/modules/admin/dialogs/term-dialog/component.scss
// module chunks = main